export const REKENING = {
    STATUS: {
        ACTIVE: true,
        NONACTIVE: false,
    },
}